import React from "react";
import { DateTime } from "luxon";
import { McModal } from "@maersk-global/mds-react-wrapper/components-core/mc-modal";
import { McButton } from "@maersk-global/mds-react-wrapper";

export default function AppDetailsModal({ isOpen, loading, appDetailsData, onClose }) {
  if (!isOpen) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = DateTime.fromISO(dateStr);
    return date.isValid ? date.toFormat("dd-MM-yyyy") : "N/A";
  };

  return (
    <McModal
      heading="Application Details"
      dimension="large"
      padding="default"
      open={isOpen}
      closed={onClose}
      closing={onClose}
      zindex={999}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <mc-loading-indicator></mc-loading-indicator>
        </div>
      ) : appDetailsData ? (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Application ID</span>
            <input
              type="text"
              value={appDetailsData.app_id || "Undefined"}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Channel</span>
            <input
              type="text"
              value={appDetailsData.status || "Undefined"}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: appDetailsData.status === "Red" ? "#d32f2f" : "#388e3c",
                fontWeight: "600",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Application Name</span>
            <input
              type="text"
              value={appDetailsData.app_name || "Undefined"}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Platform</span>
            <input
              type="text"
              value={appDetailsData.platform || "Undefined"}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Portfolio</span>
            <input
              type="text"
              value={appDetailsData.portfolio || "Undefined"}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Trigger Type</span>
            <input
              type="text"
              value={appDetailsData.trigger_type || "Undefined"}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Incident ID</span>
            <input
              type="text"
              value={appDetailsData.incident || "Undefined"}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Priority</span>
            <input
              type="text"
              value={appDetailsData.priority || "Undefined"}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Incident Date</span>
            <input
              type="text"
              value={appDetailsData.incident_dates || "Undefined"}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Added to Red Channel</span>
            <input
              type="text"
              value={formatDate(appDetailsData.added_to_red_channel)}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>First Review</span>
            <input
              type="text"
              value={formatDate(appDetailsData.first_review)}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Final Review</span>
            <input
              type="text"
              value={formatDate(appDetailsData.final_review)}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Moved to Green Channel</span>
            <input
              type="text"
              value={formatDate(appDetailsData.moved_to_green_channel_on)}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Deployment Type</span>
            <input
              type="text"
              value={appDetailsData.deployment_type || "Undefined"}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Application Representative</span>
            <input
              type="text"
              value={appDetailsData.application_representative || "Undefined"}
              disabled
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ gridColumn: "span 2", display: "flex", gap: "5px", flexDirection: "column" }}>
            <span style={{ color: "#545454", fontSize: "0.875rem", fontWeight: "600" }}>Comments</span>
            <textarea
              value={appDetailsData.comments || "-"}
              disabled
              rows={4}
              style={{
                fontSize: "0.875rem",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                background: "#f7f7f7",
                padding: "8px 12px",
                color: "#222",
                outline: "none",
                width: "100%",
                boxSizing: "border-box",
                resize: "vertical",
                fontFamily: "inherit",
              }}
            />
          </div>
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "2rem", color: "#666" }}>
          No data available for this application.
        </div>
      )}

      <McButton slot="primaryAction" appearance="primary" fit="medium" click={onClose}>
        Close
      </McButton>
    </McModal>
  );
}
